import { useState } from 'react';
import useSound from 'use-sound';
import correctAnswerBling from '../../sounds/correctAnswerBling.wav'
// import wrongAnswerBuzz from '../../sounds/wrongAnswerBuzz.wav'
import wrongAnswerBuzz from '../../sounds/fail.mp3'


import { data } from './data/data_03_sauvat_korkea_plus.js'

import kuva from './images/yli4_400x700.png'

const SauvatKorkeaPlus = ({ visibilityHandler, soundsOn }) => {


    // Vastausvaihtoehtojen ääniefektit
    const [playCorrectAnswer] = useSound(correctAnswerBling);
    const [playWrongAnswer] = useSound(wrongAnswerBuzz);


    function Reset() {

        // alert("Sauvat korkea + --> Säädetäänpäs uudelleen...,")
        visibilityHandler("Säädetään uudelleen")

    }


    return (

        <div className='sceneContainer'>

            <div id='image' className='kuvaBox'>

                <img src={kuva} alt="kuva" />


            </div>

            <div id='question'>
                <h4>{(data.kysymysteksti != null && data.kysymysteksti != "") ? data.kysymysteksti : null}</h4>
            </div>

            <div id='actions'>
                <button onClick={() => Reset()}>Säädä uudelleen</button>


            </div>
        </div>
    )

}

export default SauvatKorkeaPlus